import { render, staticRenderFns } from "./CustomerPaymentCardView.vue?vue&type=template&id=c0ce2cec&"
import script from "./CustomerPaymentCardView.vue?vue&type=script&lang=js&"
export * from "./CustomerPaymentCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports